<template>
    <div class="container">
        <p class="f18 pb10">
            财务信息
            <el-button
                    class="fr"
                    type="text"
                    @click="authOperation('1')"
                    v-for="o in operation"
                    v-if="o.name == 'modify' && $store.getters.type != 3 && detail.pay_name"
                    :key="o.rule_id">修改</el-button>
        </p>
        <el-row v-if="$store.getters.type != 3 && !detail.pay_name" class="pt20 t-c">
            <el-button type="primary" @click="modify()">完善信息</el-button>
        </el-row>
        <el-row style="background: #f6f6f6; padding: 10px" v-if="$store.getters.type != 3 && detail.pay_name">
            <el-col :span="8">支付类型：
                <span v-if="detail.pay_type==1">银行转账</span>
                <span v-if="detail.pay_type==2">支付宝</span>
                <span v-if="detail.pay_type==3">微信</span>
            </el-col>
            <el-col :span="8" v-if="detail.pay_account_type==1 || detail.pay_account_type==2">
                账户类型：
                {{detail.pay_account_type==1?'公司':'个人'}}
            </el-col>
            <el-col :span="8">开户地区：{{detail.bank_province_name}}{{detail.bank_city_name}}</el-col>
            <el-col :span="8">开户行：{{detail.bank_name}}</el-col>
            <el-col :span="8">银行账户名：{{detail.pay_name}}</el-col>
            <el-col :span="8" v-if="detail.pay_type==1">
                银行账号：
                <!--{{detail.pay_account}}-->
                <el-popover
                        placement="right-start"
                        trigger="click"
                        :content="decryptStr">
                    <span class="primary cursor" slot="reference" @click="$utils.decrypt(detail.pay_account_encryption,(res)=>{decryptStr = res})">{{detail.pay_account}}</span>
                </el-popover>
            </el-col>
            <el-col :span="8" v-if="detail.pay_type==2">支付宝账号名：{{detail.zfb_name}}</el-col>
            <el-col :span="8" v-if="detail.pay_type==2">
                支付宝账号：
                <el-popover
                        placement="right-start"
                        trigger="click"
                        :content="decryptStr">
                    <span class="primary cursor" slot="reference" @click="$utils.decrypt(detail.pay_account_encryption,(res)=>{decryptStr = res})">{{detail.pay_account}}</span>
                </el-popover>
                <!--<el-popover-->
                        <!--placement="right-start"-->
                        <!--trigger="hover"-->
                        <!--:content="detail.pay_account">-->
                    <!--<span class="primary cursor" slot="reference">{{$utils.encryptStr(detail.pay_account)}}</span>-->
                <!--</el-popover>-->
                <!--{{detail.pay_account}}-->
            </el-col>
            <el-col :span="8" v-if="detail.pay_type==2">
                银行账号：
                <el-popover
                        placement="right-start"
                        trigger="click"
                        :content="decryptStr">
                    <span class="primary cursor" slot="reference" @click="$utils.decrypt(detail.bank_account_encryption,(res)=>{decryptStr = res})">{{detail.bank_account}}</span>
                </el-popover>
                <!--{{detail.bank_account}}-->
            </el-col>
            <el-col :span="8">
                预留手机号：
                <el-popover
                        placement="right-start"
                        trigger="click"
                        :content="decryptStr">
                    <span class="primary cursor" slot="reference" @click="$utils.decrypt(detail.pay_mp_encryption,(res)=>{decryptStr = res})">{{detail.pay_mp}}</span>
                </el-popover>
            </el-col>
        </el-row>

        <div v-for="o in operation"
             v-if="detail.is_bind_wallet_bank == 1 && o.name == 'wallet'"
             :key="o.rule_id" style="margin-top: 50px;">
            <p class="f18 pb10">
                钱包信息
                <el-button class="fr"
                           type="text"
                           @click="changePassword(tableData)">
                    钱包密码管理
                </el-button>
            </p>
            <div style="background: #f6f6f6; padding: 10px">
                <p style="margin-bottom: 10px;">账户余额（元）：{{accountAmount}} </p>
                <p style="margin-bottom: 10px;">提现中金额（元）：{{tableData.withdrawing}}</p>
                <p>可提现金额（元）：{{tableData.balance}}</p>
                <div style="margin-top: 30px;" v-if="$store.getters.type != 3 && detail.pay_name">
                    <el-button size="mini"
                               @click="authOperation('2')"
                               type="primary">
                        钱包提现
                    </el-button>
                    <el-button size="mini"
                               @click="walletDetail(tableData)"
                               type="primary">
                        钱包交易记录
                    </el-button>
                    <el-button size="mini"
                               @click="billInfo(tableData)"
                               type="primary">
                        钱包交易统计
                    </el-button>
                </div>
            </div>
        </div>
        <el-dialog title="财务信息" :visible.sync="dialogFormVisible">
            <el-form size="mini" :model="form" :rules="rules" :label-width="formLabelWidth" ref="form">
                <el-form-item label="支付类型" prop="pay_type">
                    <el-select v-model="form.pay_type" placeholder="请选择" @change="clearInfo()">
                        <el-option label="银行转账" value="1"></el-option>
                        <el-option label="支付宝" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!--支付宝-->
                <div v-if="form.pay_type == 2">
                    <el-form-item label="支付宝账户名" prop="zfb_name">
                        <el-input v-model="form.zfb_name" placeholder="请输入" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="支付宝账号" prop="pay_account">
                        <el-input v-model="form.pay_account" placeholder="请输入" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="预留手机号" prop="pay_mp">
                        <el-input v-model="form.pay_mp" placeholder="请输入" auto-complete="off"></el-input>
                    </el-form-item>
                    <p style="width: 100%;height: 35px;line-height: 35px;background: #d1dbe5;text-align: center;color: #333;margin-bottom: 10px;">
                        鉴于银联用户支付货款的打款需要，另需收集该商户的银行账户信息
                    </p>
                </div>
                <!--银行转账-->
                <div>
                    <el-form-item label="账户类型" prop="pay_account_type">
                        <el-radio-group v-model="form.pay_account_type">
                            <el-radio label="1">公司</el-radio>
                            <el-radio label="2">个人</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="开户地区" prop="bank_province_code">
                        <el-select v-model="form.bank_province_code" placeholder="省" @change="getCity()" style="width: 48%;float: left">
                            <el-option v-for="p in provinces" :label="p.n" :value="p.k" :key="p.k"></el-option>
                        </el-select>
                        <el-select v-model="form.bank_city_code" placeholder="市" style="width: 48%;float: left;margin-left: 4%">
                            <el-option v-for="c in cities" :label="c.n" :value="c.k" :key="c.k"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开户行" prop="bank_id">
                        <el-select v-model="form.bank_id" placeholder="银行" @change="getBankBranch()" style="width: 48%;float: left">
                            <el-option v-for="p in banks" :label="p.n" :value="p.k" :key="p.k"></el-option>
                        </el-select>
                        <!--<el-select v-model="form.bank_branch_id" placeholder="支行" style="width: 48%;float: left;margin-left: 4%">-->
                        <!--<el-option v-for="c in bankBranchs" :label="c.n" :value="c.k" :key="c.k"></el-option>-->
                        <!--</el-select>-->
                        <el-select
                                v-model="form.bank_branch_id"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="请输入支行"
                                :remote-method="remoteMethod"
                                @change="getBranchNo"
                                style="width: 48%;float: left;margin-left: 4%"
                                :loading="loading1">
                            <el-option
                                    v-for="item in bankBranchs"
                                    :key="item.k"
                                    :label="item.n"
                                    :value="item.k">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支行行号" prop="bank_branch_no">
                        <el-input v-model="bank_branch_no" placeholder="自动带出" auto-complete="off" disabled></el-input>
                        <p class="red">请务必核对支行行号是否正确，若有误请重新选择开户行支行。若不核对，后果将由您承担。</p>
                    </el-form-item>
                    <el-form-item label="账户名称" prop="pay_name">
                        <el-input v-model="form.pay_name" placeholder="请输入" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账号" prop="pay_account" v-if="form.pay_type == 1">
                        <el-input v-model="form.pay_account" placeholder="请输入" auto-complete="off" style="ime-mode:disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账号" prop="bank_account" v-if="form.pay_type == 2">
                        <el-input v-model="form.bank_account" placeholder="请输入" auto-complete="off" style="ime-mode:disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="预留手机号" prop="pay_mp" v-if="form.pay_type == 1">
                        <el-input v-model="form.pay_mp" placeholder="请输入" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="loading" @click="submitForm('form')">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 设置、修改密码-->
        <el-dialog :title="passwordTitle" :visible.sync="passwordDialogVisible">
            <el-form size="mini" :model="passwordFrom" :rules="passwordRules" :label-width="formLabelWidth" ref="passwordFrom">
                <el-form-item label="绑定手机号：" prop="">
                    <span class="mr10">{{detail.wallet_valid_mp}}</span>
                    <el-button type="primary" :loading="codeLoading" :disabled="smsBtnDisabled" @click="smsSend()">{{smsBtn}}</el-button>
                </el-form-item>
                <el-form-item label="验证码：" prop="sms_code">
                    <el-input v-model="passwordFrom.sms_code" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="输入密码：" prop="password">
                    <el-input type="password" v-model="passwordFrom.password" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="password2">
                    <el-input type="password" v-model="passwordFrom.password2" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="passwordDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="passwordLoading" @click="submitPassword('passwordFrom')">确 定</el-button>
            </div>
        </el-dialog>
        <!--提现-->
        <el-dialog title="提现确认" :visible.sync="withdrawalDialogVisible" center>
            <div>
                <i class="el-icon-question" style="position: absolute; top: 20px; right: 60px;font-size: 18px" @click="rulesDialogVisible = true"></i>
                <div style="display:flex;">
                    <span>提现至账户：</span>
                    <div class="ml10">
                        <p>{{detail.bank_name}}</p>
                        <p>{{detail.pay_account}}</p>
                    </div>
                </div>
                <div style="display: flex" class="mt10">
                    <span>输入提现金额：</span>
                    <el-input style="width: 60%" v-model="amount" :placeholder="'可提现' + canAmount + '元'" auto-complete="off"></el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="withdrawalDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="withdrawalLoading" @click="submitWithDrawal()">确 定</el-button>
            </div>
        </el-dialog>
        <!--钱包明细-->
        <el-dialog title="钱包交易记录" :visible.sync="walletDetailDialogVisible">
            <el-table
                    v-loading="walletLoading"
                    :data="walletData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="sourceType"
                        label="交易类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sourceType == '1' || scope.row.sourceType == '2'">配送收益</span>
                        <span v-if="scope.row.sourceType == '3'">挂账</span>
                        <span v-if="scope.row.sourceType == '4'">提现</span>
                        <span v-if="scope.row.sourceType == '5'">消费</span>
                        <span v-if="scope.row.sourceType == '6'">扣款</span>
                        <span v-if="scope.row.sourceType == '11'">销售收入</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="updateTime"
                        :show-overflow-tooltip="true"
                        label="交易时间">
                    <template slot-scope="scope">
                        <span>{{$utils.formatDate(scope.row.updateTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '0'">初始化</span>
                        <span v-if="scope.row.status == '1'">已提交</span>
                        <span v-if="scope.row.status == '2'">审核通过</span>
                        <span v-if="scope.row.status == '3'">审核拒绝</span>
                        <span v-if="scope.row.status == '4'">转账中</span>
                        <span v-if="scope.row.status == '5'">转账成功</span>
                        <span v-if="scope.row.status == '6'">转账失败</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="amount"
                        label="金额（元）">
                    <template slot-scope="scope">
                        <span>{{scope.row.flowType == 1 ? '+': '-'}}{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="serviceAmt"
                        label="手续费（元)">
                </el-table-column>
                <el-table-column
                        :show-overflow-tooltip="true"
                        prop="serviceRemark"
                        label="备注">
                </el-table-column>
            </el-table>
        </el-dialog>
        <!--账单统计-->
        <el-dialog title="钱包交易统计" :visible.sync="billDialogVisible">
            <div style="border: 1px solid #EBEEF5" v-loading="billLoading">
                <el-row style="background: #f2f2f2; padding: 0 10px">
                    <el-col :span="4">当日收入（元）</el-col>
                    <el-col :span="4">当月收入（元）</el-col>
                    <el-col :span="5">累计收入（元）</el-col>
                    <el-col :span="5">当月提现（元）</el-col>
                    <el-col :span="6">累计提现成功（元）</el-col>
                </el-row>
                <el-row style="padding: 0 10px">
                    <el-col :span="4">{{billData.todayIncome}}</el-col>
                    <el-col :span="4">{{billData.monthIncome}}</el-col>
                    <el-col :span="5">{{billData.totalIncome}}</el-col>
                    <el-col :span="5">{{billData.monthWithdraw}}</el-col>
                    <el-col :span="6">{{billData.totalWithdraw}}</el-col>
                </el-row>
            </div>

        </el-dialog>
        <!--提现规则-->
        <el-dialog width="36%" title="提现规则" :visible.sync="rulesDialogVisible">
            <div class="red">
                <p>1.申请提现并通过审核后1-2个工作日到账，以实际到账时间为准；</p>
                <p>2.节假日暂不受理提现事宜，如节假日发起提现申请，将顺延到工作日处理；</p>
                <p>3.提现手续费=（5 + 提现金额 x 0.6%）元</p>
            </div>
        </el-dialog>
        <!--身份验证-->
        <el-dialog width="30%" title="身份验证" :visible.sync="authDialogVisible">
            <div>
                <span>输入钱包密码：</span>
                <el-input type="password" style="width: 60%" v-model="authPassword" placeholder="请输入" auto-complete="off"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="authDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="authChanges()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'dashboard',
        data() {
            var checkMobile = (rule, value, callback) => {
                if (value && !this.$valid.mobile(value)) {
                    callback(new Error('请输入正确格式的手机号'));
                }
                callback();
            };
            var checkAccount = (rule, value, callback) => {
                if (value && !this.$valid.isHalf(value)) {
                    callback(new Error('请输入半角字符'));
                }
//                if (value && !this.$valid.rate1(value)) {
//                    callback(new Error('请输入数字'));
//                }
                callback();
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    return callback(new Error('请输入密码'));
                }else if (!this.$valid.password(value)) {
                    callback(new Error('请输入6-15位字母或者数字密码'));
                }else {
                    callback();
                }
            };
            return{
                detail: {},
                dialogFormVisible: false,
                formLabelWidth: '120px',
                provinces: [],
                cities: [],
                banks: [],
                bankBranchs: [],
                allBankBranchs: [],
                form: {
                    id: '',
                    type: this.$store.getters.type,
                    pay_type: '1',
                    pay_account_type: '1',
                    bank_province_code: '',
                    bank_city_code: '',
//                    bank_name: '',
                    bank_id: '',
                    bank_branch_id: '',
                    pay_name: '',
                    zfb_name: '',
                    pay_account: '',
                    bank_account: '',
                    pay_mp: '',
                    mp: this.$store.getters.account,
                    operator: this.$store.getters.username
                },
                loading: false,
                rules: {
                    pay_type: [
                        {required: true, message: '请选择支付类型', trigger: 'change'}
                    ],
                    pay_account_type: [
                        {required: true, message: '请选择账户类型', trigger: 'blur'}
                    ],
                    bank_province_code: [
                        {required: true, message: '请输入开户地区', trigger: 'change'}
                    ],
                    bank_id: [
                        {required: true, message: '请选择开户行', trigger: 'blur'}
                    ],
                    pay_name: [
                        {required: true, message: '请输入账户名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在50个字符以内', trigger: 'blur'}
                    ],
                    zfb_name: [
                        {required: true, message: '请输入账户名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在50个字符以内', trigger: 'blur'}
                    ],
                    pay_account: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
//                        {min: 1, max: 25, message: '长度在25个字符以内', trigger: 'blur'},
                        { validator: checkAccount, trigger: 'blur'}
                    ],
                    bank_account: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
//                        {min: 1, max: 25, message: '长度在25个字符以内', trigger: 'blur'},
                        { validator: checkAccount, trigger: 'blur'}
                    ],
                    pay_mp: [
                        { validator: checkMobile, trigger: 'blur'}
                    ]
                },
                loading1: false,
                bank_branch_no: '',
                decryptStr: '',
                detail1: {},
                tableData: {},
                passwordDialogVisible: false,
                passwordTitle: '',
                codeLoading: false,
                smsBtn: '获取验证码',//发送验证码按钮
                smsBtnDisabled: false,//默认可点击
                waitingTime: 60,//
                passwordFrom: {
                    sms_code: '',
                    password: '',
                    password2: '',
                },
                passwordRules: {
                    sms_code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    password2: [
                        {required: true, message: '请确认密码', trigger: 'blur'}
                    ],
                },
                passwordLoading: false,
                withdrawalDialogVisible: false,
                withdrawalLoading: false,
                amount: '',
                canAmount: '',
                walletDetailDialogVisible: false,
                walletData: [],
                billDialogVisible: false,
                billData: [],
                rulesDialogVisible: false,
                accountAmount: '',
                authDialogVisible: false,
                authPassword: '',
                authNum: '',
                walletLoading: false,
                billLoading: false
            }
        },
        created (){
            this.initInfo();
        },
        computed: {
            operation: function(){
                return this.$store.getters.operation
            }
        },
        methods: {
            initInfo() {
                //获取用户信息
                this.$store.dispatch('GetInfo').then(res => {
                    this.detail = res.data;
                })
                let params = {account_id: this.$store.getters.userId,encrypted: 1};
                this.$api.post(this.$apiUrl.userInfo,params,(res)=>{
                    this.detail1 = res.data;
                    this.getWalletInfo();
                })
            },
            clearInfo() {
                if(this.form.pay_type == this.detail.pay_type){
                    for(let k in this.detail){
                        for(let k1 in this.form){
                            if(k == k1){
                                this.form[k1] = this.detail[k];
                                if((k == 'bank_branch_id' || k == 'bank_id') && this.detail[k] == '0'){
                                    this.form[k1] = '';
                                }
                                if(k == 'pay_type'){
                                    this.form[k1] = this.detail[k].toString();
                                }
                            }
                        }
                    }
                }else{
                    this.form.pay_name = '';
                    this.form.pay_account = '';
                    this.form.bank_account = '';
                }

                // this.getProvince();
                // this.getBank();
            },
            modify() {
                this.dialogFormVisible = true;
                if(this.detail.bank_branch_id && this.detail.bank_branch_id != '0'){
                    this.bankBranchs.push({k:this.detail.bank_branch_id,n:this.detail.bank_branch_name});
                    this.getBranchNo(this.detail.bank_branch_id)
                }
                for(let k in this.detail1){
                    for(let k1 in this.form){
                        if(k == k1){
                            this.form[k1] = this.detail1[k];
                            if((k == 'bank_branch_id' || k == 'bank_id') && this.detail1[k] == '0'){
                                this.form[k1] = '';
                            }
                        }
                    }
                }

                if(this.form.pay_account_type != '1' && this.form.pay_account_type != '2'){
                    this.form.pay_account_type = 0;
                }
                this.form.pay_mp = this.form.pay_mp == null ? '' : this.form.pay_mp;
                this.form.pay_account = this.form.pay_account == null ? '' : this.form.pay_account;
                this.form.bank_account = this.form.bank_account == null ? '' : this.form.bank_account;

              //获取省市
                this.getProvince();
                this.getCity(true);
                //获取银行
                this.getBank();
                this.getBankBranch(true);

                this.form.pay_type = this.form.pay_type.toString();
            },
            //获取省
            getProvince() {
                this.$api.get(this.$apiUrl.getProvince,{},(res)=>{
                    this.provinces = [];
                    for(let k in res.data){
                        this.provinces.push({k:k,n:res.data[k]});
                    }
                })
            },
            //获取城市
            getCity(flag) {
                if(this.form.bank_province_code){
                    this.$api.get(this.$apiUrl.getCity,{code: this.form.bank_province_code},(res)=>{
                        this.cities = [];
                        if(!flag) this.form.bank_city_code = '';
                        for(let k in res.data){
                            this.cities.push({k:k,n:res.data[k]});
                        }
                    })
                }
            },
            //获取银行
            getBank() {
                this.$api.get(this.$apiUrl.getBank,{},(res)=>{
                    this.banks = [];
                    for(let k in res.data){
                        this.banks.push({k:k,n:res.data[k]});
                    }
                })
            },
            //获取支行
            getBankBranch(flag) {
                if(this.form.bank_id){
                    this.$api.get(this.$apiUrl.getBankBranch,{bank_id: this.form.bank_id},(res)=>{
                        this.allBankBranchs = [];
                        if(!flag) this.form.bank_branch_id = '';
                        for(let k in res.data){
                            this.allBankBranchs.push({k:k,n:res.data[k]});
                        }
                    })
                }
            },
            getBranchNo(v) {
                if(v){
                    this.$api.get(this.$apiUrl.getBankNo,{branch_id: v},(res)=>{
                        this.bank_branch_no = res.data[0].bank_no;
                    })
                }else{
                    this.bank_branch_no = '';
                }
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading1 = true;
                    setTimeout(() => {
                        this.loading1 = false;
                        let temp = [];
                        temp = this.allBankBranchs.filter(function(item){
                            return item.n.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                        if(temp.length > 50){
                            this.bankBranchs = temp.slice(temp.length - 50);
                        }else{
                            this.bankBranchs = temp;
                        }
//                        console.log(this.bankBranchs.length)
                    }, 600);
                } else {
                    this.bankBranchs = [];
                }
            },
            //提交表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!this.form.bank_branch_id || this.form.bank_branch_id == ''){
                            this.$message.warning('请选择支行');
                            return;
                        }
                        this.loading = true;
                        let params = {...this.form};
                        params.pay_name = params.pay_name == null ? null : params.pay_name.replace(/\r\n/g,'').replace(/\s/g,'');
                        params.pay_mp = params.pay_mp == null ? null : params.pay_mp.replace(/\r\n/g,'').replace(/\s/g,'');
                        params.pay_account = params.pay_account == null ? null : params.pay_account.replace(/\r\n/g,'').replace(/\s/g,'');
                        params.bank_account = params.bank_account == null ? null : params.bank_account.replace(/\r\n/g,'').replace(/\s/g,'');
                        this.$api.post(this.$apiUrl.commercialModify,params,(res)=>{
                            this.loading = false;
                            this.$message.success('编辑成功');
                            this.dialogFormVisible = false;
                            this.initInfo();
                        },(res)=>{
                            this.loading = false;
                            this.$message.error(res.message);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //获取钱包信息
            getWalletInfo() {
                let params = {
                    // schoolId: localStorage.getItem('schoolId'),
                    userType: this.detail1.type == 1 ? 2 : 3,
                    userId: localStorage.getItem('userId')
                }
                this.$apiJava.get(this.$apiUrl.walletInfo,params,(res)=>{
                    if(res.data.list && res.data.list.length > 0) {
                        this.tableData = res.data.list[0]
                        this.accountAmount = parseFloat((res.data.list[0].balance + res.data.list[0].withdrawing).toFixed(2))
                        this.canAmount = res.data.list[0].balance
                    }
                },res=> {

                }, 'payment')
            },
            //验证身份
            authOperation(num) {
                if(num == 1 && this.detail.is_bind_wallet_bank == 0) { //一直是周期打款
                    this.modify();
                }
                if(num == 2 || (num == 1 && this.detail.is_bind_wallet_bank == 1)) { //钱包提现或者为设置过钱包提现
                    if(this.tableData.status == '5') {
                        this.passwordTitle = '设置钱包密码'
                        this.passwordDialogVisible = true
                        this.passwordFrom.password = ''
                        this.passwordFrom.password2 = ''
                        this.passwordFrom.sms_code = ''
                        return this.$message.warning('请先设置钱包密码')
                    }
                    this.authDialogVisible = true;
                    this.authPassword = '';
                }
                this.authNum = num
            },
            authChanges() {
                let params = {
                    userId: localStorage.getItem('userId'),
                    password: this.authPassword,
                    userType: this.detail1.type == 1 ? 2 : 3
                }
                this.$apiJava.post(this.$apiUrl.passwordCheck,params,(res)=>{
                    this.authDialogVisible = false
                    if(this.authNum === '1') {
                        this.modify()
                    } else {
                        this.withdrawal(this.tableData)
                    }
                },res=> {
                    this.$message.error(res.message);
                }, 'payment')
            },
            // 提现
            withdrawal(val) {
                this.walletStatus(val.status)
                if(val.status == 7) {
                    this.withdrawalDialogVisible = true
                    this.amount = ''
                }
            },
            submitWithDrawal() {
                if (this.amount.split('.')[1] && this.amount.split('.')[1].length>2) {
                    return this.$message.error('提现金额最多输入两位小数')
                }
                if(this.amount > this.canAmount) {
                    return this.$message.error('提现金额超限')
                }
                let params = {
                    userId: localStorage.getItem('userId'),
                    amount: this.amount,
                    userType: this.detail1.type == 1 ? 2 : 3
                }
                this.$apiJava.post(this.$apiUrl.serviceAmount,params,(res)=>{
                    let tips = '本次提现：' + res.data.amount + '元，手续费预计为：' + res.data.serviceAmt + '元'
                    this.$confirm(tips, '提示', {
                        confirmButtonText: '确定提现',
                        cancelButtonText: '我再想想',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        params.amount = res.data.amount;
                        this.$apiJava.post(this.$apiUrl.withdraw,params,(res)=>{
                            this.withdrawalDialogVisible = false
                            this.getWalletInfo();
                            this.$message.success('提现申请已提交，等待工作人员处理。');
                        },res=> {
                            this.$message.error(res.message);
                        }, 'payment')
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                },res=> {
                    this.$message.error(res.message);
                }, 'payment')
            },
            //钱包明细
            walletDetail(val) {
                this.walletStatus(val.status)
                if(val.status == 7) {
                    this.walletDetailDialogVisible = true
                    this.walletLoading = true
                    let params = {
                        userId: localStorage.getItem('userId'),
                            userType: this.detail1.type == 1 ? 2 : 3,
                    }
                    this.$apiJava.get(this.$apiUrl.walletData,params,(res)=>{
                        this.walletData = res.data.list
                        this.walletLoading = false
                    },res=> {
                        this.withdrawalDialogVisible = false
                        this.walletLoading = false
                        this.$message.error(res.message);
                    }, 'payment')
                }
            },
            //账单统计
            billInfo(val) {
                this.walletStatus(val.status)
                if(val.status == 7) {
                    this.billLoading = true
                    this.billDialogVisible = true
                    let params = {
                        userId: localStorage.getItem('userId'),
                        userType: this.detail1.type == 1 ? 2 : 3,
                    }
                    this.$apiJava.get(this.$apiUrl.billData,params,(res)=>{
                        this.billData = res.data
                        this.billLoading = false
                    },res=> {
                        this.billDialogVisible = false
                        this.billLoading = false
                        this.$message.error(res.message);
                    }, 'payment')
                }
            },
            //钱包状态
            walletStatus(status) {
                this.passwordFrom.password = ''
                this.passwordFrom.password2 = ''
                this.passwordFrom.sms_code = ''
                // status 5-未设置密码 6-被冻结 7-正常
                if(status == 5) {
                    this.passwordTitle = '设置钱包密码'
                    this.passwordDialogVisible = true
                } else if(status == 6) {
                    return this.$message.error('账户被冻结！');
                }
            },
            //修改密码
            changePassword(val) {
                this.walletStatus(val.status)
                if(val.status == 7) {
                    this.passwordTitle = '修改钱包密码'
                    this.passwordDialogVisible = true
                }
            },
            //获取验证码
            smsSend() {
                this.codeLoading = true;
                this.smsBtnDisabled = true;
                this.smsBtn = this.waitingTime + 's';
                var inter = setInterval(() => {
                    this.waitingTime--;
                    this.smsBtn = this.waitingTime + 's';
                    if(this.waitingTime === 0) {
                        this.smsBtn = '重新获取';
                        this.smsBtnDisabled = false;
                        this.waitingTime = 60;
                        clearInterval(inter);
                    }
                },1000);
                let params = {
                    mp: this.detail.wallet_valid_mp,
                    account_type: '1'
                };
                this.$api.get(this.$apiUrl.sendWalletSms,params,()=>{
                    this.codeLoading = false;
                    this.$message.success('发送成功');
                },()=>{
                    this.codeLoading = false;
                    this.$message.error('发送失败，请稍后再试');
                })
            },
            //修改密码
            submitPassword(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.passwordFrom.password !== this.passwordFrom.password2) {
                            return this.$message.error('两次密码不一致，请重新输入');
                        }
                        this.passwordLoading = true
                        let params = {
                            userType: this.detail1.type == 1 ? 2 : 3,
                            userId: localStorage.getItem('userId'),
                            mobile: this.detail.wallet_valid_mp,
                            password: this.passwordFrom.password,
                            sms_code: this.passwordFrom.sms_code
                        }
                        this.$apiJava.post(this.$apiUrl.passwordChange,params,()=>{
                            this.passwordLoading = false;
                            this.$message.success('修改成功');
                            this.passwordDialogVisible = false;
                            this.getWalletInfo();
                        },()=>{
                            this.passwordLoading = false;
                            this.$message.error('修改失败');
                        }, 'payment')

                    }
                })
            },

        }
    }
</script>
<style lang="scss"  scoped>
    .el-row{
        line-height: 35px;
    }
    @media screen and (max-width: 840px){
        .el-col-8{
            width: 100%;
            /*margin-bottom: 10px;*/
        }
    }
</style>



// WEBPACK FOOTER //
// financeInfo.vue?6e66de18